export default {
  projectId: '',
  districtId: '',
  districts: [],
  uuid: '',
  localityId: '',
  pluginId: ''
};
